import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { Routes, RouterModule } from '@angular/router';

import { Global } from './global';
import { DocumentosComponent } from './documentos/documentos.component';

const routes: Routes = [
  {
    path: ':sin_id/:pol_id/:id_peticion',
    component: DocumentosComponent
  }, {
    path: ':sin_id/:pol_id',
    component: DocumentosComponent
  }, {
    path: 'documentos/:sin_id/:pol_id/:id_peticion',
    component: DocumentosComponent
  },{
    path: 'documentos/:sin_id/:pol_id',
    component: DocumentosComponent
  },{
    path: '**',
    component: DocumentosComponent
  }
];

@NgModule({
  declarations: [
    AppComponent,
    DocumentosComponent,
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot(routes, { useHash: true }),
    FormsModule,
    ReactiveFormsModule
  ],
  providers: [Global],
  bootstrap: [AppComponent]
})
export class AppModule { }
